import { render, staticRenderFns } from "./BudgetForOneDepartment.vue?vue&type=template&id=c57b5e18&"
import script from "./BudgetForOneDepartment.vue?vue&type=script&lang=js&"
export * from "./BudgetForOneDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c57b5e18')) {
      api.createRecord('c57b5e18', component.options)
    } else {
      api.reload('c57b5e18', component.options)
    }
    module.hot.accept("./BudgetForOneDepartment.vue?vue&type=template&id=c57b5e18&", function () {
      api.rerender('c57b5e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/budget/BudgetForOneDepartment.vue"
export default component.exports